import Marquee from 'react-fast-marquee';

const BRANDS = ['MINI GT', 'HOT WHEELS', 'TARMAC WORKS', 'INNO64', 'POP RACE', 'GREENLIGHT', 'PARA 64', 'GCD MODELS', 'CM MODELS', 'BMC MODELS', 'ALMOST REAL', 'POSTER CARS'];

export default function BrandsMarquee() {
  return (
    <section id="brands" data-testid="brands-marquee" className="py-16 md:py-20 border-y border-gray-100 overflow-hidden bg-white">
      <Marquee speed={40} gradient={false} className="overflow-hidden">
        {BRANDS.map((brand, i) => (
          <span key={`${brand}-${i}`} className="font-heading text-4xl sm:text-5xl md:text-6xl font-black uppercase tracking-tighter mx-8 md:mx-12 whitespace-nowrap select-none" style={{ WebkitTextStroke: '2px rgba(0,0,0,0.25)', color: 'transparent' }}>
            {brand}
            <span className="text-[#FF2A2A] mx-6 text-3xl">&#x2022;</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
